import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { H5 } from "../../../../../AbstractElements";
import { SubscripationTitle } from "../../../../../Constants/Constants";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { SubScripationChart } from "../../../../../Data/General/Widgets/General";

const Subscripation = () => {
  return (
    <Col xl="4" sm="6">
      <Card className="earning-chart">
        <DashboardCommonHeader title={SubscripationTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="py-0">
          <H5 className="mt-2">$2,249</H5>
          <div id="Subscripationchart">
            <ReactApexChart type="area" options={SubScripationChart} series={SubScripationChart.series} height={165} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Subscripation;
